import { render, staticRenderFns } from "./TutorialPracticeTask.vue?vue&type=template&id=1e09a416&scoped=true&"
import script from "./TutorialPracticeTask.vue?vue&type=script&lang=js&"
export * from "./TutorialPracticeTask.vue?vue&type=script&lang=js&"
import style0 from "./TutorialPracticeTask.vue?vue&type=style&index=0&id=1e09a416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e09a416",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCardActions})
